import React from 'react';
import { AppBreadcrumbs } from '../breadcrumbs/AppBreadcrumbs';
import { LeftbarToggle } from './LeftbarToggle';
import { RightbarToggle } from './RightbarToggle';

export const TopbarSubrow: React.FC = () => (
  <div
    data-shell-subrow
    className="hidden md:flex h-10 px-3 items-center justify-between gap-2 border-t border-border/60 bg-background text-foreground"
  >
    <div className="flex items-center gap-2 min-w-0 flex-1">
      <LeftbarToggle />
      <span className="h-4 w-px bg-border shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        <AppBreadcrumbs />
      </div>
    </div>
    <RightbarToggle />
  </div>
);
